/**
 * The two marks of Mauvely's own conversation: the verified seal, and the line
 * that stands where the composer would be. Who gets the seal is decided by
 * `lib/relay/official.ts`, never here.
 */

import { ds } from '../../ds';
import { useT } from '../../i18n';
import './chat.css';

export function VerifiedMark({ size = 14 }: { size?: number }) {
  const { Icon } = ds();
  const t = useT();
  const label = t('conversation.verified');
  return (
    <span className="rl-verified" role="img" aria-label={label} title={label}>
      <Icon name="Verified" size={size} />
    </span>
  );
}

/** Nobody replies here. Said once, in place of the composer. */
export function ReadOnlyNotice() {
  const t = useT();
  return <div className="rl-readonly">{t('conversation.readOnly')}</div>;
}
